/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberShiftCancelMutationRequest, PostApiBarberShiftCancelMutationResponse, PostApiBarberShiftCancel400, PostApiBarberShiftCancel401, PostApiBarberShiftCancel403, PostApiBarberShiftCancel404, PostApiBarberShiftCancel500 } from "../entities/PostApiBarberShiftCancel";

function getPostApiBarberShiftCancelUrl() {
  const res = { method: 'POST', url: `/api/barber/shift/cancel` as const }
  return res
}

/**
 * @description Мастер отменяет активную или запланированную бронь кресла
 * @summary Отменить бронь смены
 * {@link /api/barber/shift/cancel}
 */
export async function postApiBarberShiftCancel(data: PostApiBarberShiftCancelMutationRequest, config: Partial<RequestConfig<PostApiBarberShiftCancelMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostApiBarberShiftCancelMutationResponse, ResponseErrorConfig<PostApiBarberShiftCancel400 | PostApiBarberShiftCancel401 | PostApiBarberShiftCancel403 | PostApiBarberShiftCancel404 | PostApiBarberShiftCancel500>, PostApiBarberShiftCancelMutationRequest>({ method : "POST", url : getPostApiBarberShiftCancelUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}